import { licensesActions } from "./licenses-slice";
import { uiActions } from "./ui-slice";
import { ROLES } from "./auth-slice";
import { fetchRequest, fetchFileRequest } from "../services/api";
import {
  getLicensesGetRequest,
  getPutLicenseRequest,
  getPostLicenseRequest,
  getDeleteLicenseRequest,
  getLicensesGetRequestForCustomer,
  getLicenseFileGetRequest,
} from "../services/licenses-request";
import {
  getBindRequest,
  getUnbindRequest,
} from "../services/hardware-requests";
import getErrorMessage from "../helpers/error-messages";
import { customersActions } from "./customers-slice";
import { hardwaresActions } from "./hardware-slice";

export const fetchLicenses = () => {
  return async (dispatch, getState) => {
    const role = getState().auth.authUser.role;
    dispatch(uiActions.setLicensesLoading(true));
    try {
      const requestConfiguration =
        role === ROLES.ROLE_ADMINISTRATOR
          ? getLicensesGetRequest()
          : getLicensesGetRequestForCustomer();
      const licenses = await fetchRequest(requestConfiguration);
      dispatch(licensesActions.set(licenses));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    } finally {
      dispatch(uiActions.setLicensesLoading(false));
    }
  };
};

export const updateLicense = (license) => {
  return async (dispatch) => {
    try {
      await fetchRequest(getPutLicenseRequest(license));
      dispatch(licensesActions.updateLicense(license));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const addLicense = (customerId, license) => {
  return async (dispatch) => {
    try {
      const addedLicense = await fetchRequest(
        getPostLicenseRequest(customerId, license)
      );
      dispatch(licensesActions.addLicense(addedLicense));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const deleteLicense = (license) => {
  return async (dispatch) => {
    try {
      await fetchRequest(getDeleteLicenseRequest(license.id));
      dispatch(licensesActions.unbindLicense(license.hardwareId));
      dispatch(licensesActions.delLicense(license.id));
      dispatch(
        uiActions.enqueNotification({
          message: "Deleted",
          variant: "success",
        })
      );
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const bindLicenseToCustomer = (licenseId, hardwareId) => {
  return async (dispatch) => {
    try {
      const bindResult = await fetchRequest(
        getBindRequest(licenseId, hardwareId)
      );
      dispatch(
        licensesActions.bindLicense({ licenseId, bindResult: bindResult })
      );
      dispatch(
        hardwaresActions.bind({ licenseId, bindResult: bindResult })
      );
      dispatch(
        uiActions.enqueNotification({
          message: "Hardware assigment changed",
          variant: "success",
        })
      );
    } catch (error) {
      const translatedError = getErrorMessage(error.message);
      dispatch(uiActions.enqueNotification(translatedError));
    }
  };
};

export const unbindLicenseFromCustomer = (licenseId, hardwareId) => {
  return async (dispatch) => {
    try {
      await fetchRequest(getUnbindRequest(licenseId));
      dispatch(licensesActions.unbindLicense(hardwareId));
      dispatch(hardwaresActions.unbind(hardwareId));
      dispatch(
        uiActions.enqueNotification({
          message: "Hardware ubnound from license",
          variant: "success",
        })
      );
    } catch (error) {
      const translatedError = getErrorMessage(error.message);
      dispatch(uiActions.enqueNotification(translatedError));
    }
  };
};

export const downloadLicense = (id) => {
  return async (dispatch) => {
    try {
      await fetchFileRequest(getLicenseFileGetRequest(id));      
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};
